// Shared chart palette + apex defaults for the reusable dashboard components.
// Keep this the single source of truth so every dashboard reads as one system.

export const CHART_COLORS = [
  "#00BD73", // dimitra green (primary)
  "#3498DB",
  "#7C4DFF",
  "#FF9800",
  "#1ABC9C",
  "#E74C3C",
  "#F1C40F",
  "#9B59B6",
  "#34495E",
  "#16A085",
];

export const GRID_COLOR = "#ECEFF1";
export const TEXT_MUTED = "#78909C";

// Options merged into every chart. Component-level options override these.
export function baseChartOptions(id) {
  return {
    chart: {
      id,
      fontFamily: "inherit",
      toolbar: { show: true },
      animations: { enabled: true },
    },
    colors: CHART_COLORS,
    grid: { borderColor: GRID_COLOR },
    dataLabels: { enabled: false },
    legend: { position: "bottom", labels: { colors: TEXT_MUTED } },
    tooltip: { theme: "light" },
  };
}

// Deep-ish merge sufficient for apex option objects (shallow + nested chart/xaxis/yaxis).
export function mergeOptions(base, override = {}) {
  const out = { ...base, ...override };
  ["chart", "xaxis", "yaxis", "plotOptions", "legend", "grid", "tooltip"].forEach((k) => {
    if (base[k] || override[k]) out[k] = { ...(base[k] || {}), ...(override[k] || {}) };
  });
  return out;
}
